import { EventBus } from "../event-bus";

export default {
  data() {
    return {
      eventBusForMasterHandler: null
    };
  },

  methods: {
    // registerEventBusForMaster(handler) {
    //   console.log(this.$route.name);
    //   EventBus.$on(this.$route.name, (this.eventBusForMasterHandler = handler));
    // },

    // unregisterEventBusForMaster() {
    //   EventBus.$off("reloadFolderTree" , "reloadFolderTree" );
    // },

    registerEventBusForMaster(handler) {
      // console.log(
      //   `registerEventBusForMaster: ${this._getToRouteName(this.$route.name) ||
      //     this.$route.name}`
      // );
      EventBus.$on(
        this._getToRouteName(this.$route.name) || this.$route.name, //trong TH refresh tại trang detail > phải lấy theo tên của trang detai;
        (this.eventBusForMasterHandler = handler)
      );
    },

    unregisterEventBusForMaster() {
      // console.log("unregisterEventBusForMaster: " + this.$route.name);
      EventBus.$off(this.$route.name, this.eventBusForMasterHandler);
    },

    notifyMasterForDataChange(event) {
      // console.log(
      //   "notifyMasterForDataChange: " + this._getToRouteName(this.$route.name)
      // );
      let masterRouteName = this._getToRouteName(this.$route.name);
      EventBus.$emit(masterRouteName, event);
    },

    goBack() {
      this._handleGoBack(this.$route.name);
    },

    _handleGoBack(fromRouteName) {
      switch (fromRouteName) {
        default:
          let toRouteName = this._getToRouteName(fromRouteName);
          !toRouteName
            ? this.$router.back()
            : this.$router.replace({
                name: toRouteName,
                params: this._handleGoBackParams(fromRouteName, toRouteName),
                query: this._handleGoBackQuery(fromRouteName, toRouteName)
              });
      }
    },

    _getToRouteName(fromRouteName) {
      switch (fromRouteName) {
        case "detail-job":
          return "job-index";
        case "detail-job-assigned":
          return "job-index-assigned";
        case "job-index-dept-assigned":
          return "detail-job-dept-assigned";
        case "job-index-coordinate":
          return "detail-job-coordinate";
        case "QuanTriNguoiDungDetail":
          return "quanTriNguoiDung";
        case "QuanTriDonViDetail":
          return "QuanTriDonVi";
        case "quanlySoDiDetail":
          return "quanlySoDi";
        case "quanlySoDenDetail":
          return "quanlySoDen";
        case "vbChoBanHanhDetail":
          return "vbChoBanHanh";
        case "adminstration-concludeDetail":
          return "adminstration-conclude";
        case "adminstration-bcCVTrongTamDetail":
          return "adminstration-bcCVTrongTam";
        case "adminstration-quyCheQuyDinhDetail":
          return "adminstration-quyCheQuyDinh";
        case "adminstration-getCarDetail":
          return "adminstration-getCar";
        case "adminstration-bookflight-detail":
          return "adminstration-bookflight";
        case "adminstration-bookHotel-detail":
          return "adminstration-bookHotel";
        case "tdhvpDocInDetail":
          return "tdhvpDocInIndex";
        case "tdhvpDocInVtDetail":
          return "tdhvpDocInVtIndex";
        case "tdhvpDocOutDetail":
          return "tdhvpDocOutIndex";
        case "tdhvpDocOutVtDetail":
          return "tdhvpDocOutVtIndex";
        case "adminstration-suaChuaNho-detail":
          return "adminstration-suaChuaNho";
        case "adminstration-detail":
          return "adminstration-index";
        default:
          return null;
      }
    },

    _handleGoBackParams(fromRouteName, toRouteName) {
      return this.$route.params;
    },

    _handleGoBackQuery(fromRouteName, toRouteName) {
      return this.$route.query;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/goBackMixin.js